import { Table } from "@cofano/cck";
import { LocationFromQuery } from "view/locations/LocationDetails";
import { intl } from "LocaleWrapper";
import { useFrontendTable } from "components/table";
import { DataFormat, usePermission } from "utils";

const LocationContactsTable = ({ contacts }: { contacts?: LocationFromQuery["contacts"] }) => {
	const { isSkipperOrShipManager } = usePermission();

	const filteredContacts = isSkipperOrShipManager
		? (contacts ?? []).filter(c => c.visibleForShip !== false)
		: (contacts ?? []);

	const { tableProps } = useFrontendTable({
		id: "locationContacts",
		content: filteredContacts,
		saveForOrganizationEnabled: false,
	});

	return (
		<Table
			{...tableProps}
			disableFooter
			columns={[ {
				id: "name",
				title: intl.formatMessage({ id: "FIRST_NAME" }),
			}, {
				id: "insertion",
				title: intl.formatMessage({ id: "INSERTION" }),
			}, {
				id: "surName",
				title: intl.formatMessage({ id: "SURNAME" }),
			}, {
				id: "email",
				title: intl.formatMessage({ id: "LOCATION_CONTACT_EMAIL" }),
			}, {
				id: "telephone",
				title: intl.formatMessage({ id: "TELEPHONE" }),
			}, {
				id: "fax",
				title: intl.formatMessage({ id: "FAX" }),
			}, {
				id: "visibleForShip",
				defaultVisible: !isSkipperOrShipManager,
				title: intl.formatMessage({ id: "VISIBLE_FOR_SHIP" }),
				render: (row) => DataFormat.boolean(row.visibleForShip),
			} ]} />
	);
};

export default LocationContactsTable;
